/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { v4 } from "uuid";
import React, { ReactNode, createContext, useContext, useEffect, useRef, useState } from "react";
import ReactGA from "react-ga4";
import toast from "react-hot-toast";
import { getAirports } from "../../../../../api/booking/booking";
import { getItineraryDetailsAPI } from "../../../../../api/getItineraryDetails";
import { saveItineraryDetailsAPI } from "../../../../../api/itinerary/saveItineraryDetails";
import { cloneSharedTravelPlanIfNeeded } from "../../../../../api/itinerary/cloneSharedTravelPlanIfNeeded";
import { modifyItineraryAPI } from "../../../../../api/llm/modifyItinerary";
import { modifyItineraryStreaming } from "../../../../../api/streaming/chatStreaming";
import { ROUTES } from "../../../../../constant";
import {
  DialogSelected,
  ENVIRONMENT_TYPE,
  INVALID_JSON_PROMPT,
  LLM_RESPONSE_ERROR,
} from "../../../../../constant/common";
import { SELECTED_CHAT_DATA } from "../../../../../constant/dummyData";
import { STREAMING_ENABLE, environment, ENABLE_GA_CUSTOM_EVENTS } from "../../../../../constant/environment";
import { GA_EVENTS, GA_LABEL_ENUMS, triggerGAEvent } from "../../../../../constant/google-analytics/GAEvents";
import { Messages } from "../../../../../constant/messages/toastMessages";
import { useDataStreamingContext } from "../../../../../context/dataStreamingContext/DataStreamingContext";
import { iDataStreamingContext } from "../../../../../context/dataStreamingContext/dataStreamingContextInterface";
import { StateContext } from "../../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../../context/globalContext/interface";
import { useHistoryContext } from "../../../../../context/historyContext/historyContext";
import { iHistoryContext } from "../../../../../context/historyContext/interface";
import { iSocketContext, useSocketContext } from "../../../../../context/socketContext/SocketContext";
import { ScreenTypes } from "../../../../../enums";
import { GetTripType } from "../../../../../helpers/checkTripType";
import { setItemInSessionStorage } from "../../../../../hooks/sessionStorage";
import useCustomErrorHandler from "../../../../../hooks/useCustomErrorHandler";
import useValidateDate from "../../../../../hooks/useValidateDate";
import { iChatStreamingPayload } from "../../../../../interface/common";
import { SaveItineraryDetailsResponse } from "../../../../../interface/saveItinarary";
import { BookingDetails, iChatData, iCityDetailsResult, iHotelStayTypes } from "../../../../../types";
import { checkIfThereIsDestination, getItineraryVersion, scrollToBottom, scrollToTop } from "../../../../../utils";
import { toastMessage } from "../../../../../utils/ToastProvider";
import { appendErrorMessageTochat } from "../../../../../utils/appendErrorMessageToChat";
import { getFlightTravelData } from "../../../../../utils/booking/flight/getFlightTravelData";
import { getFlightTravelDetails } from "../../../../../utils/booking/flight/getFlightTravelDetails";
import { consoleLog } from "../../../../../utils/consoleLog/consoleLog";
import { handleRoomAllocation } from "../../../../../utils/handleRoomAllocation";
import { checkIfUserIsLoggedIn } from "../../../../../utils/loginAndLocalStorageutils";
import { iItineraryDetailsContext } from "./itineraryDetailsInterface";
import { usePixelEvent } from "../../../../../hooks/usePixelEvent";
import { extractFlightSegments } from "../../../../../utils/booking/flight/itineraryFlightDetails";
import { TransformLocations } from "../../../../../helpers/transformLocations";
import { useNavigationUrl } from "../../../../../hooks/useNavigationUrl";
import { ASKZOYA_CONST } from "../../../../BookingInProgress/component/askZoya/askZoyaConstant";
import { updateHotelPayloadData } from "../../../../BookingInProgress/utils/updateHotelPayloadData";
import { isEmbedMode } from "../../../../../utils/embedMode";
import { DESKTOP_MEDIA_QUERY } from "../../../../../constant/breakpoints";

let abortPlanTripDetails = new AbortController();

const ItineraryContext = createContext({} as iItineraryDetailsContext);
export const ItineraryContextProvider = ({ children }: { children: ReactNode }) => {
  const { navigateWithParams } = useNavigationUrl();
  const state = useContext(StateContext);
  const {
    setSelectedHotelRoomArr,
    setFlightAvailabilityData,
    setSignInClick,
    setSaveScreenState,
    setLoginCreateAccountState,
    setNav,
    tripForNDays,
    setTripForNDays,
    setExtraMeta,
    extraMeta,
    sharedItineraryId,
    setDataStream,
    query,
    setShareClick,
    setIsItinerarySavedFlag,
    setSelectedChatData,
    chatData,
    selectedChatData,
    scrollContainerRef,
    setScreen,
    isMobile,
    setChatData,
    userInfo,
    setUserInfo,
    setModifyItineraryPrompt,
    setBookingDetails,
    setSelectedCityListPrompContext,
    setSelectedFlightOptions,
    selectedFlightOptions,
    setFlightData,
    setHotelData,
    appConfig,
    setShowMore,
    setAirPorts,
    isFetchingAirports,
    setIsFetchingAirports,
    setPrevRoute,
    setHotelPagination,
    prevRoute,
    socketId,
    setFirstScreen,
    accessJWT,
    setIsValidAccessToken,
    setBreadList,
    setSelectedHotels,
    abortController,
    abortControllerRef,
    setOpenLoaderOverlay,
    setIsFetchingMobileAirports,
    setChatInputText,
    setIsDataUpdateComplete,
    setGuestList,
    setHotelTravelersList,
    setRecentTravelersList,
    setAskZoyaRecordId,
    setUpdateFilters,
    setHideDetails,
    bookClickFromItinerary,
    screen,
    bookingDetails,
    cancelHandleBookClickRef,
    firstScreen,
    setFlightTTL,
  }: iGlobalContext = state;
  const { saveHistory, getHistory, currentHistoryId }: iHistoryContext = useHistoryContext();

  const { disableInput, setDisableInput, chatAbortController, chatAbortControllerRef }: iDataStreamingContext =
    useDataStreamingContext();
  const { streamingFlagAndResponseType, setStreamingFlagAndResponseType, handleCloseSocketConnection }: iSocketContext =
    useSocketContext();
  const [showEditActivityFlag, setShowEditActivityFlag] = React.useState(false);
  const validateDate = useValidateDate();
  const { handleCustomError } = useCustomErrorHandler();
  const { sendPixelEvent } = usePixelEvent();
  // Axios controller to cancel API call
  const controller = new AbortController();
  const controllerAbortUpdateTrip = new AbortController();
  const hasCancelledRef = useRef(false);
  const [openModifyItineraryDialog, setOpenModifyItineraryDialog] = useState({
    isOpen: false,
    message: "",
  });
  const isDesktopOrTablet = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;
  const shouldUsenewAirportSearch =
    appConfig?.find((item: any) => item.key === "use_new_airportSearch")?.value === "true" ? true : false;
  React.useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For other browsers
    }, 200);
    scrollToTop(scrollContainerRef);
    setNav("");
    setTripForNDays([]);
    setDataStream("");
    const localPlanTrip = window.sessionStorage.getItem("_extra_meta");
    if (localPlanTrip !== null) {
      setTripForNDays(JSON.parse(localPlanTrip).planTripArray);
    }
    if (!userInfo?.loggedIn) checkIfUserIsLoggedIn(setIsValidAccessToken, setUserInfo);
    return () => {
      controllerAbortUpdateTrip.abort();
      controller.abort();
      setDataStream("");
    };
  }, []);
  React.useEffect(() => {
    if (sharedItineraryId !== "") setIsItinerarySavedFlag(true);
    else {
      setIsItinerarySavedFlag(false);
    }
  }, [sharedItineraryId]);

  // Save Itinerary
  function handleSaveItinerary() {
    triggerGAEvent(GA_LABEL_ENUMS.itinerary_details_save_click);
    sendPixelEvent("interactedWithChat", { event: GA_EVENTS[GA_LABEL_ENUMS.itinerary_details_save_click]?.label });
    if (selectedChatData?.isSaved) return;
    setExtraMeta({
      ...extraMeta,
      planTripArray: tripForNDays,
      query: query,
    });
    setSaveScreenState(true);
    if (userInfo?.loggedIn)
      setLoginCreateAccountState({
        flag: true,
        page: DialogSelected.SAVE_ITINERARY,
      });
    else setLoginCreateAccountState({ flag: true, page: DialogSelected.LOGIN });
  }

  // Onclick function to handle Back button click
  function handleBackButton() {
    if (
      streamingFlagAndResponseType?.isStillStreamingFlag === true &&
      streamingFlagAndResponseType?.responseType !== "itinerary"
    ) {
      setChatInputText("");
      triggerGAEvent(GA_LABEL_ENUMS.itinerary_details_back_click);
      if (isMobile) navigateWithParams(ROUTES.TopDestination);
      else {
        setScreen("");
        setFirstScreen(() => ScreenTypes.topDestination);
      }
      return;
    }
    const dupChatData = JSON?.parse(JSON?.stringify(chatData));
    const reverseChatData = dupChatData?.reverse();
    const promptContextChatData = reverseChatData?.find((ele: iChatData) => ele?.prompt?.length > 1);
    let promptContext: any = [];
    if (promptContextChatData?.prompt?.length)
      promptContext = [
        ...promptContextChatData?.prompt,
        {
          role: "user",
          content: chatData[chatData?.length - 2]?.maskedMessage ?? chatData[chatData?.length - 2]?.message,
        },
      ];
    else {
      promptContext = [
        {
          role: "user",
          content: chatData[chatData?.length - 2]?.maskedMessage ?? chatData[chatData?.length - 2]?.message,
        },
      ];
    }

    const buildInterruptedBubble = (last: any) => {
      const hasAnswer =
        !!last?.singleSelectedDestination || (last?.destinationList?.length ?? 0) > 0;
      if (hasAnswer && isEmbedMode()) return { ...last, isLoading: false, isProcessInterrupted: true };
      return {
        id: v4(),
        message: "",
        prompt: promptContext,
        isUserMessage: false,
        isLoading: false,
        destinationList: [],
        singleSelectedDestination: false,
        isProcessInterrupted: true,
      };
    };

    setChatInputText("");
    handleCancel();
    handleCancelStreaming();
    setOpenLoaderOverlay(false);
    triggerGAEvent(GA_LABEL_ENUMS.itinerary_details_back_click);
    handleCloseSocketConnection();
    if (isMobile) navigateWithParams(prevRoute === ROUTES.MyTrips ? ROUTES.MyTrips : ROUTES.TopDestination);
    else {
      if (firstScreen === ScreenTypes.SavedTrip || firstScreen === ScreenTypes.MyTrips) {
        setScreen("");
        return;
      } else {
        setScreen("");
        setFirstScreen(() => ScreenTypes.topDestination);
      }
    }

    if (streamingFlagAndResponseType?.responseType === "itinerary" && chatData?.length === 2) {
      setChatData((prev: iChatData[]) => [
        ...prev.slice(0, -1),
        buildInterruptedBubble(prev[prev.length - 1]),
      ]);
      if (isMobile) navigateWithParams(ROUTES.NewTrip);
      else {
        setScreen("");
        setFirstScreen(() => ScreenTypes.NewTrip);
      }
    } else if (
      streamingFlagAndResponseType?.chatId === "" &&
      streamingFlagAndResponseType?.isStillStreamingFlag === true
    ) {
      consoleLog("CANCEL HERE");
      setChatData((prev: any) => [
        ...prev.slice(0, -1),
        buildInterruptedBubble(prev[prev.length - 1]),
      ]);
    }
    setStreamingFlagAndResponseType({
      isStillStreamingFlag: false,
      chatId: "",
      responseType: "",
      showMoreClickFlag: false,
    });
  }

  let fetchAirportController: any = useRef(null);

  const getTravelDetails = (tripData: iCityDetailsResult[]) => {
    if (!tripData || tripData?.length === 0) {
      return [];
    }
    const travelDetails: any[] = [];

    tripData?.forEach((trip) => {
      // Count the number of days in the city
      const numberOfDays = trip?.tripDetails?.length || 0;
      // Collect flight details for the city
      const flights: any = [];
      trip?.tripDetails?.forEach((day) => {
        const dayFlights = day?.itinerary_by_time_of_the_day_data?.filter(
          (activity: any) => activity?.activity_type === "transportation.flight"
        );

        dayFlights?.forEach((flight: any) => {
          flights?.push({
            departure_city_name: [
              flight?.departure_city_name,
              flight?.departure_city_state,
              flight?.departure_city_country,
            ]
              .filter(Boolean)
              .join(", "),
            departure_city_latitude: flight?.departure_city_lattitude ?? flight?.departure_city_latitude ?? "",
            departure_city_longitude: flight?.departure_city_longitude || "",
            departure_city_country_code: flight?.departure_city_country_code || "",
            arrival_city_name: [flight?.arrival_city_name, flight?.arrival_city_state, flight?.arrival_city_country]
              .filter(Boolean)
              .join(", "),
            arrival_city_country_code: flight?.arrival_city_country_code || "",
            arrival_city_latitude: flight?.arrival_city_lattitude ?? flight.arrival_city_latitude ?? "",
            arrival_city_longitude: flight?.arrival_city_longitude || "",
          });
        });
      });

      // Add the city details with number of days and flights
      travelDetails?.push({
        city_name: trip?.city_name || "",
        number_of_days: numberOfDays,
        flights: flights,
      });
    });

    return travelDetails;
  };

  const extractFlightCities = (data: any) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    const citiesSet = new Set();

    data.forEach((location: any) => {
      location.flights.forEach((flight: any) => {
        const departureCity = JSON.stringify({
          name: flight?.departure_city_name,
          latitude: flight?.departure_city_lattitude ?? flight?.departure_city_latitude,
          longitude: flight?.departure_city_longitude,
          countryCode: flight?.departure_city_country_code,
        });

        const arrivalCity = JSON.stringify({
          name: flight.arrival_city_name,
          latitude: flight.arrival_city_lattitude ?? flight.arrival_city_latitude,
          longitude: flight.arrival_city_longitude,
          countryCode: flight.arrival_city_country_code,
        });

        citiesSet.add(departureCity);
        citiesSet.add(arrivalCity);
      });
    });

    return Array.from(citiesSet).map((city: any) => JSON.parse(city));
  };
  const airportRequestInProgress = useRef(false);
  // Dedupe rapid-fire saveItineraryBeforeBooking calls for the same itinerary.
  // Book Flight / Book Hotel click → handleBook (HB1) → saveItineraryBeforeBooking
  // PUT → navigate to /booking → BookingLoader mounts → handleBook again (HB2,
  // per CLAUDE.md's load-bearing double-invocation) → saveItineraryBeforeBooking
  // PUT again. Same chat id, same payload, within ~1 s. Cache the last { id,
  // promise } so HB2 reuses HB1's in-flight (or just-completed) save instead of
  // hitting `/app/v1/users/itineraries` a second time. Window matches the
  // realistic gap between the two handleBook invocations.
  const lastBookingSaveRef = useRef<{ id: string; ts: number; result: any } | null>(null);
  // In-flight share — HB2 may fire while HB1's PUT is still on the wire,
  // before lastBookingSaveRef has been stamped. Return the same promise so
  // both callers await the single network request.
  const inflightBookingSaveRef = useRef<{
    id: string;
    promise: Promise<any>;
  } | null>(null);
  const BOOKING_SAVE_DEDUPE_MS = 10000;
  const getAirportData = async (selectedChatDataArgs: any) => {
    if (airportRequestInProgress.current) return;
    airportRequestInProgress.current = true;
    const flightHistory = getTravelDetails(selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList);

    const airportPayload = extractFlightCities(flightHistory);
    const isValidCity = (city: any) =>
      Object.values(city).every((value) => value && !value.toString().includes("undefined"));
    const cities = airportPayload?.filter(isValidCity);
    if (!cities || cities.length === 0) {
      setIsFetchingMobileAirports(false);
      setBookingDetails((prevData) => ({
        ...prevData,
        hideFlights: false,
      }));
      airportRequestInProgress.current = false;
      return null;
    }

    const cityData = shouldUsenewAirportSearch ? TransformLocations(cities) : cities;
    const requestBody = {
      userId: userInfo.id,
      cities: cityData,
      radius: "100 miles",
    };
    fetchAirportController.current = new AbortController();
    abortControllerRef.current = abortController;
    try {
      const data = await getAirports(accessJWT, requestBody, abortController, shouldUsenewAirportSearch);
      if (fetchAirportController.current.signal.aborted) {
        setIsFetchingMobileAirports(false);
        return null;
      }
      setAirPorts(data);
      if (data && typeof data === "object") {
        setBookingDetails((prev: any) => ({
          ...prev,
          airPort: prev?.airPort?.map((item: any) => {
            const departureAirports = data[item.departureAddress] || [];
            const arrivalAirports = data[item.arrivalAddress] || [];
            return {
              ...item,
              departure: item.departure || departureAirports[0]?.code || "",
              arrival: item.arrival || arrivalAirports[0]?.code || "",
              departureAirportFullName: item.departureAirportFullName || departureAirports[0]?.fullName || "",
              arrivalAirportFullName: item.arrivalAirportFullName || arrivalAirports[0]?.fullName || "",
            };
          }),
        }));
      }
      airportRequestInProgress.current = false;
      return data;
    } catch (err) {
      setAirPorts([]);
      airportRequestInProgress.current = false;
      console.error("Error", err);
      return [];
    }
  };
  const [itineraryInfo, setItineraryInfo] = useState<BookingDetails>();

  const getItineraryDetails = async () => {
    const { id: itineraryId } = selectedChatData;
    if (!itineraryId) return;

    try {
      const response = await getItineraryDetailsAPI(itineraryId, accessJWT);
      consoleLog(["ITINERARY ERROR", response]);
      if (response?.statusCode === 400 || response?.statusCode === 404) return null;
      if (response?.statusCode !== 200) {
        handleCustomError(response?.statusCode, "itinerary.details");
        return null;
      }
      const metaData =
        typeof response.data.metaData === "string" ? JSON.parse(response?.data?.metaData) : response.data.metaData;
      const chatData = metaData[0]?.selectedChatData;
      if (chatData) setSelectedChatData(chatData);

      const updatedBookingDetails = { ...response.data.bookFilter };
      setItineraryInfo(updatedBookingDetails);
    } catch (error) {
      console.error("Error fetching itinerary details:", error);
    }
  };

  useEffect(() => {
    if (prevRoute !== ROUTES.TopDestination && selectedChatData?.id) getItineraryDetails();
  }, []);

  async function handleShare() {
    if (!selectedChatData?.isSaved) {
      setShareClick(true);
      setTimeout(() => {
        handleSaveItinerary();
      }, 1000);
    }
  }

  const [noOfCitySelected, setNoOfCitySelected] = useState(1);
  useEffect(() => {
    setNoOfCitySelected(
      selectedChatData?.destinationList?.reduce((acc: number, destListEle: iCityDetailsResult) => {
        if (destListEle.checkedFlag) return acc + 1;
        else return acc;
      }, 0)
    );
  }, [selectedChatData]);

  function handleOnShare() {
    // setTimeout(() => {
    //   toastMessage.success(Messages["shareItinerary.success"].messageTitle, Messages["shareItinerary.success"].message);
    // }, 100);
  }

  const [tempSelectedChatData, setTempSelectedChatData] = useState(
    selectedChatData?.destinationList?.filter((ele: iCityDetailsResult) => ele.checkedFlag)
  );
  useEffect(() => {
    setTempSelectedChatData(selectedChatData?.destinationList?.filter((ele: iCityDetailsResult) => ele.checkedFlag));
  }, [selectedChatData]);

  function handleEdit() {
    if (isMobile) navigateWithParams(ROUTES.TopDestination);
    setModifyItineraryPrompt(`Modify the itinerary for ${selectedChatData.tripName}`);
    setChatData((prev: iChatData[]) => [
      ...prev,
      {
        id: v4(),
        message: inputValue,
        isUserMessage: true,
        prompt: selectedChatData?.prompt,
        isLoading: false,
        destinationList: [],
        singleSelectedDestination: false,
      },
      {
        id: v4(),
        message: "",
        prompt: selectedChatData?.prompt,
        isUserMessage: false,
        isLoading: true,
        destinationList: [],
        singleSelectedDestination: false,
      },
    ]);
  }
  function extractStatement(str: string) {
    const match = str.match(/"statement":\s*"([^"]*)"/); // Match statement and handle newlines manually
    return match ? match[1].replace(/\\n/g, "\n") : null; // Replace escaped newlines with actual newlines
  }
  async function handleSendMessageStreaming() {
    setSelectedChatData({ ...SELECTED_CHAT_DATA });
    toast.dismiss();
    setModifyItineraryPrompt(`Modify the itinerary for ${selectedChatData.tripName}`); //  used to enable auto scroll in Destop
    if (chatData.length > 0 && chatData[chatData.length - 1].isLoading) {
      toastMessage.info(
        Messages["SaveItinerary.inputFieldLoad"].messageTitle,
        Messages["SaveItinerary.inputFieldLoad"].message
      );
      return;
    }
    if (inputValue === "") {
      toastMessage.info(
        Messages["SaveItinerary.inputFieldEnter"].messageTitle,
        Messages["SaveItinerary.inputFieldEnter"].message
      );
      return;
    }
    setChatData((prev: iChatData[]) => [
      ...prev,
      {
        id: v4(),
        message: inputValue,
        isUserMessage: true,
        prompt: [],
        isLoading: false,
        destinationList: [],
        singleSelectedDestination: false,
      },
      {
        id: v4(),
        message: "",
        prompt: [],
        isUserMessage: false,
        isLoading: true,
        destinationList: [],
        singleSelectedDestination: false,
      },
    ]);
    setInputValue("");
    setDisableInput(true);
    chatAbortControllerRef.current = chatAbortController;

    let payload: iChatStreamingPayload = {
      userId: userInfo?.id || "",
      userInput: inputValue,
      isModify: true,
      chatId: selectedChatData?.id || "",
      currentItineray: selectedChatData?.results || "",
      socketId: socketId || "",
      iteneryInput: null,
    };

    let response = await modifyItineraryStreaming(accessJWT, payload, chatAbortController.signal);

    if (!response && chatAbortController.signal.aborted) {
      setChatData((prev: iChatData[]) => {
        const length = prev.length;
        if (prev.length > chatData.length) return [...prev.slice(0, length - 2)];
        return prev;
      });
      return;
    }

    if (response === null || (!response && !chatAbortController.signal.aborted) || !response?.data?.result) {
      setDisableInput(false);
      appendErrorMessageTochat(chatData, setChatData, response?.message ?? LLM_RESPONSE_ERROR.jsonError.message);

      return;
    }

    if (response?.data?.result) {
      setChatData((prevChatData) => {
        if (prevChatData.length > 0) {
          const message = prevChatData[prevChatData.length - 1].message;
          const extractedMessage = extractStatement(message);
          let lastChatData: iChatData = {
            ...prevChatData[prevChatData.length - 1], // Copy the last element
            prompt: response?.data?.messages,
            isLoading: false,
            message: extractedMessage ? extractedMessage : prevChatData[prevChatData.length - 1].message,
            results: response?.data?.result,
          };
          const itineraryVersion = getItineraryVersion(chatData, lastChatData);
          lastChatData = {
            ...lastChatData,
            itinerary_version: itineraryVersion,
          };
          if (lastChatData?.message === "" && lastChatData?.destinationList?.length === 0) {
            if (isMobile) navigateWithParams(ROUTES.TopDestination);
            else setScreen("");
            lastChatData = {
              id: v4(),
              message: LLM_RESPONSE_ERROR.jsonError.message,
              isUserMessage: false,
              prompt: [],
              isLoading: false,
              destinationList: [],
              singleSelectedDestination: false,
            };
          }
          setSelectedChatData(lastChatData);
          return [
            ...prevChatData.slice(0, -1), // All elements except the last
            lastChatData,
          ];
        }
        return prevChatData; // If empty, return as is
      });
    }

    setDisableInput(false);
  }
  async function handleSendMessage() {
    toast.dismiss();
    setModifyItineraryPrompt(`Modify the itinerary for ${selectedChatData.tripName}`);
    if (chatData.length > 0 && chatData[chatData.length - 1].isLoading) {
      toastMessage.info(Messages["SaveItinerary.inputFieldLoad"].message);
      return;
    }
    if (inputValue === "") {
      toastMessage.info(Messages["SaveItinerary.inputFieldEnter"].message);
      return;
    }
    setChatData((prev: iChatData[]) => [
      ...prev,
      {
        id: v4(),
        message: inputValue,
        isUserMessage: true,
        prompt: [],
        isLoading: false,
        destinationList: [],
        singleSelectedDestination: false,
      },
      {
        id: v4(),
        message: "",
        prompt: [],
        isUserMessage: false,
        isLoading: true,
        destinationList: [],
        singleSelectedDestination: false,
      },
    ]);
    setInputValue("");
    setDisableInput(true);
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    let response = await modifyItineraryAPI(
      accessJWT,
      isMobile,
      userInfo?.id || "",
      inputValue,
      [],
      selectedChatData?.results || {},
      abortController.signal,
      appConfig
    );

    if (!response && abortController.signal.aborted) {
      setChatData((prev: iChatData[]) => {
        const length = prev.length;
        if (prev.length > chatData.length) return [...prev.slice(0, length - 2)];
        return prev;
      });
      return;
    }
    if (
      response === null ||
      (!response && !abortController.signal.aborted) ||
      !response?.data?.result ||
      checkIfThereIsDestination(response) === LLM_RESPONSE_ERROR.jsonError.error
    ) {
      response = await modifyItineraryAPI(
        accessJWT,
        isMobile,
        userInfo?.id || "",
        inputValue + INVALID_JSON_PROMPT,
        [],
        selectedChatData?.results || {},
        abortController.signal,
        appConfig
      );
    }

    if (response === null || (!response && !abortController.signal.aborted) || !response?.data?.result) {
      setDisableInput(false);
      appendErrorMessageTochat(chatData, setChatData, response?.message ?? LLM_RESPONSE_ERROR.jsonError.message);
      return;
    }
    response = checkIfThereIsDestination(response);
    if (response === LLM_RESPONSE_ERROR.jsonError.error) {
      appendErrorMessageTochat(chatData, setChatData, response?.message ?? LLM_RESPONSE_ERROR.jsonError.message);
      setDisableInput(false);
      if (environment === ENVIRONMENT_TYPE.PRODUCTION) {
        toastMessage.error(Messages["api.break.down"].message, Messages["api.break.down"].message);
      } else {
        toastMessage.error(
          Messages["SaveItinerary.destinationError"].messageTitle,
          Messages["SaveItinerary.destinationError"].message
        );
      }
      return;
    }
    let citiesList = [];
    if (response?.data?.cities) {
      citiesList = response?.data?.cities;
    }
    processedAndGetDestinationImageURL(citiesList, response, false);
    setDisableInput(false);
  }
  async function processedAndGetDestinationImageURL(
    citiesList: iCityDetailsResult[],
    response: any,
    showMore: boolean
  ) {
    if (citiesList.length > 0) {
      setSelectedCityListPrompContext(null);
      const tempResponse = citiesList.map((ele: any, index: number) => ({
        ...ele,
        id: v4(),
        checkedFlag: true,
        locations: [],
        imageURL: selectedChatData?.destinationList[index]?.imageURL,
      }));

      const newId = v4();
      const itineraryVersion = getItineraryVersion(chatData, response?.data?.results);
      setSelectedChatData({
        ...response?.data,
        city_wise_itinerary: [],
        cities: [],
        messages: [],
        result: "",
        fromCity: response?.data?.from,
        noOfDays: response?.data?.numberOfdays,
        id: newId,
        message: "",
        preText: response?.data?.preText,
        postText: response?.data?.postText,
        // prompt: response?.data?.messages,
        prompt: [],
        isUserMessage: false,
        isLoading: false,
        singleSelectedDestination: response?.data?.singleCity,
        destinationList: tempResponse,
        itinerary_version: itineraryVersion,
      });
      setChatData((prev: iChatData[]) => [
        ...prev.slice(0, prev.length - 1),
        {
          ...response?.data,
          city_wise_itinerary: [],
          cities: [],
          messages: [],
          result: "",
          fromCity: response?.data?.from,
          noOfDays: response?.data?.numberOfdays,
          id: showMore ? prev[prev.length - 1].id : newId,
          message: "",
          preText: response?.data?.preText,
          postText: response?.data?.postText,
          // prompt: response?.data?.messages,
          prompt: [],
          isUserMessage: false,
          isLoading: false,
          singleSelectedDestination: response?.data?.singleCity,
          destinationList: showMore ? [...prev[prev.length - 1].destinationList, ...tempResponse] : tempResponse,
          itinerary_version: itineraryVersion,
        },
      ]);

      if (ENABLE_GA_CUSTOM_EVENTS) {
        ReactGA.event({
          category: "Top Destination",
          action: `User has recieved the itinerary list created`,
          label: `User prompt is ${response?.data?.query}`,
        });
      }
    } else {
      setChatData((prev: iChatData[]) => [
        ...prev.slice(0, prev.length - 1),
        {
          id: v4(),
          message: response?.data?.result,
          prompt: [],
          isUserMessage: false,
          isLoading: false,
          destinationList: [],
          singleSelectedDestination: false,
        },
      ]);

      if (isMobile) navigateWithParams(ROUTES.TopDestination);
      else setScreen("");
      scrollToBottom(scrollContainerRef);
    }
  }

  useEffect(() => {
    if (!isFetchingAirports) {
    }
  }, [isFetchingAirports]);
  /**
   * chat input
   */
  const [inputValue, setInputValue] = useState("");

  /**
   * Handling cancelling Send message or
   * open Itinerary details or Show More
   */

  const [showChatLoaderFlag, setShowChatLoaderFlag] = useState(false);
  function handleCancelStreaming() {
    hasCancelledRef.current = true;
    setShowChatLoaderFlag(false);
    setScreen("");
    chatAbortController.abort();
    if (chatAbortControllerRef.current) {
      chatAbortControllerRef.current.abort();
      setDisableInput(false);
    }
  }

  function handleCancel() {
    hasCancelledRef.current = true;
    setIsFetchingMobileAirports(false);
    setShowChatLoaderFlag(false);
    setScreen("");
    abortPlanTripDetails.abort();
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      setDisableInput(false);
    }
    if (chatAbortControllerRef.current) {
      chatAbortControllerRef.current.abort();
      setDisableInput(false);
    }
  }

  //Navigation
  const handleNavigateToBooking = () => {
    setTimeout(() => {
      if (isMobile) {
        navigateWithParams(ROUTES.BookingInProgress);
      } else {
        setScreen(ScreenTypes.newBooking);
      }
    }, 500);
    if (hasCancelledRef.current) return;
    if (abortController?.signal?.aborted) {
      setIsFetchingMobileAirports(false);
      setIsFetchingAirports(false);
      return;
    }
  };
  /**
   * Editing activity
   */
  function handleEditActivity(data: any) {}

  const handleNav = () => {
    isMobile ? navigateWithParams(ROUTES.AdjustTrip) : setScreen(ScreenTypes.Adjust);
  };

  // Save itinerary
  async function saveItineraryBeforeBooking(selectedChatDataArgs: any, userId?: string) {
    const selectedChatData = selectedChatDataArgs;
    const callId = selectedChatData?.id;
    // Dedupe: clicking Book Flight / Book Hotel on the itinerary details page
    // fires `handleBook` twice (HB1 from click + HB2 from BookingLoader mount,
    // per CLAUDE.md's load-bearing double-invocation), and each invocation
    // calls `saveItineraryBeforeBooking`. Without this, the click produced 2×
    // identical PUTs to `/app/v1/users/itineraries` plus the per-
    // bookingDetails-change PUTs from useBookingProgress — 4+ total. Two
    // levels of dedupe:
    //   1. In-flight share — if HB2 fires while HB1's PUT is still on the
    //      wire, return the SAME promise so both callers await one request.
    //   2. Post-completion cache — if HB2 fires after HB1 has resolved (but
    //      within the dedupe window), return HB1's resolved backend id
    //      directly, no new PUT.
    const now = Date.now();
    if (
      inflightBookingSaveRef.current &&
      inflightBookingSaveRef.current.id === callId
    ) {
      consoleLog(["SAVE ITINERARY BEFORE BOOKING — joined in-flight", { id: callId }]);
      return inflightBookingSaveRef.current.promise;
    }
    if (
      lastBookingSaveRef.current &&
      lastBookingSaveRef.current.id === callId &&
      now - lastBookingSaveRef.current.ts < BOOKING_SAVE_DEDUPE_MS
    ) {
      consoleLog([
        "SAVE ITINERARY BEFORE BOOKING — deduped (recent)",
        { id: callId, age: now - lastBookingSaveRef.current.ts },
      ]);
      return lastBookingSaveRef.current.result;
    }
    consoleLog(["CHAT ARGS", selectedChatData]);
    // Wrap the actual save body in a promise so concurrent callers (HB1 still
    // awaiting while HB2 fires) share the SAME network request via the
    // inflight ref above. We don't await here yet — assign first, await
    // after.
    const savePromise = (async () => {
    toast.dismiss();
    const metaData: any = {
      selectedChatData: {
        ...selectedChatData,
        isSaved: true,
        prompt: [],
        postText: "",
        preText: "",
      },
    };
    let saveItineraryPayload: any = {
      tripName: selectedChatData?.tripName || "",
      userId: userId || userInfo?.id,
      metaData,
      // status: selectedChatData?.isSaved ? "saved" : "draft",
      numberOfDaysSelected: Number(selectedChatData.noOfDays),
      year: "",
      selectedMonth: "",
      is_admin_created: userInfo?.role === 1,
      data: {},
    };
    if (!selectedChatData?.isSaved) {
      saveItineraryPayload = {
        ...saveItineraryPayload,
        status: "draft",
        historyId: currentHistoryId || "",
      };
    }
    // const abortController = new AbortController();
    abortControllerRef.current = abortController;
    const response: SaveItineraryDetailsResponse = await saveItineraryDetailsAPI(
      accessJWT,
      saveItineraryPayload,
      selectedChatData?.isSaved ? "PUT" : "POST",
      selectedChatData.id,
      abortController.signal
    );
    consoleLog(["SAVE ITINERARY RESPONSE", response]);
    if (response?.statusCode === 200) {
      let checkIfMultipleListFlag = true;
      let tempChatData = chatData?.map((chatDataEle: iChatData) => {
        if (chatDataEle.id === selectedChatData.id) {
          checkIfMultipleListFlag = false;
          const updatedSelectedChatData = {
            ...chatDataEle,
            isSaved: true,
            id: response?.data?.id,
          };
          setSelectedChatData(updatedSelectedChatData);
          return updatedSelectedChatData;
        }
        consoleLog(["SAVE ITINERARY RESPONSE", chatDataEle]);
        return chatDataEle;
      });
      if (checkIfMultipleListFlag) {
        tempChatData = chatData?.map((chatDataEle: any) => {
          if (!chatDataEle?.singleSelectedDestination && chatDataEle?.destinationList.length > 0) {
            return {
              ...chatDataEle,
              destinationList: chatDataEle?.destinationList.map((destEle: iChatData) => {
                if (destEle.id === selectedChatData.id) {
                  const updatedSelectedChatData = {
                    ...destEle,
                    isSaved: true,
                    id: response?.data?.id,
                  };
                  setSelectedChatData(updatedSelectedChatData);
                  return updatedSelectedChatData;
                }
                return destEle;
              }),
            };
          }
          return chatDataEle;
        });
      }
      setChatData(tempChatData);

      saveHistory(tempChatData, "PUT");
      getHistory(true);
      setIsItinerarySavedFlag(true);
      // Stamp the dedupe ref so HB2 (and any other rapid-fire callers) see
      // the same backend id without re-PUTing. Keyed on the ORIGINAL chat id
      // we were called with — that's what HB2's selectedChatData.id will
      // still be on the first frame after navigation.
      lastBookingSaveRef.current = {
        id: callId,
        ts: Date.now(),
        result: response?.data?.id,
      };
      return response?.data?.id;
    } else {
      consoleLog(["SAVE ITINERARY", response?.code]);
      if (response?.code !== "ERR_CANCELED")
        toastMessage.error(Messages["api.error"].messageTitle, Messages["api.error"].message);
      // setIsFetchingAirports(false);
      return null;
    }
    })();
    // Publish promise so concurrent callers join it instead of starting a
    // second PUT, then clear the in-flight ref once it settles.
    inflightBookingSaveRef.current = { id: callId, promise: savePromise };
    try {
      return await savePromise;
    } finally {
      if (inflightBookingSaveRef.current?.promise === savePromise) {
        inflightBookingSaveRef.current = null;
      }
    }
  }

  const hotelRatingParse = (input: string): number[] => {
    const regex = /^\d+(,\d+)*$/;

    if (regex.test(input)) {
      return input.split(",").map(Number);
    } else {
      return [3];
    }
  };
  function convertRangeToString(range: any) {
    if (!range || typeof range !== "string") return "";

    const [start, end] = range.split("-").map(Number);
    if (!isNaN(start) && !isNaN(end)) {
      return `${start},${end}`;
    }
    return "";
  }

  const parseAirlineNames = (input: string | null | undefined): string[] => {
    if (typeof input !== "string" || input.trim() === "") {
      return [];
    }
    return input.split(",").map((name) => name.trim());
  };

  const getHotelTravelDetails = (tripData: iHotelStayTypes[]) => {
    if (!tripData || tripData.length === 0) {
      return true;
    }

    for (const trip of tripData) {
      if (trip?.tripDetails?.length > 0) {
        for (const day of trip.tripDetails) {
          // Match any accommodation type — hotel, resort, apartment, bnb, boutique.
          // The earlier strict "accommodation.hotel" prefix silently dropped
          // resort/apartment/bnb/boutique bookings on this code path.
          const dayHotels = day?.itinerary_by_time_of_the_day_data?.filter((activity) =>
            activity?.activity_type?.toLowerCase?.()?.startsWith("accommodation.")
          );
          if (dayHotels && dayHotels.length > 0) {
            for (const hotel of dayHotels) {
              if (
                !hotel.activity_type ||
                !hotel.accommodation_location_city ||
                !hotel.accommodation_location_country_code
              ) {
                return true;
              }
            }
            return false;
          }
        }
      }
    }

    // Return true if no hotels
    return true;
  };

  function validateTripRequiredFields(selectedChatData: any): {
    isValid: boolean;
    missingFields: string[];
  } {
    if (!selectedChatData) {
      return {
        isValid: false,
        missingFields: [""],
      };
    }
    const missingFields: string[] = [];

    selectedChatData?.destinationList?.forEach((destination: any) => {
      destination?.tripDetails?.forEach((tripDetail: any) => {
        tripDetail?.itinerary_by_time_of_the_day_data?.forEach((itinerary: any) => {
          //flight
          if (itinerary?.activity_type?.toLowerCase?.() === "transportation.flight"?.toLowerCase?.()) {
            if (!itinerary.departure_city_name) missingFields.push(`departure_city_name`);
            if (!itinerary.departure_city_state) missingFields.push(`departure_city_state`);
            if (!itinerary.departure_city_country) missingFields.push(`departure_city_country`);
            if (!itinerary.departure_city_country_code) missingFields.push(`departure_city_country_code`);
            if (!itinerary.departure_city_latitude) missingFields.push(`departure_city_latitude`);
            if (!itinerary.departure_city_longitude) missingFields.push(`departure_city_longitude`);
            if (!itinerary.arrival_city_name) missingFields.push(`arrival_city_name`);
            if (!itinerary.arrival_city_state) missingFields.push(`arrival_city_state`);
            if (!itinerary.arrival_city_country) missingFields.push(`arrival_city_country`);
            if (!itinerary.arrival_city_country_code) missingFields.push(`arrival_city_country_code`);
            if (!itinerary.arrival_city_latitude) missingFields.push(`arrival_city_latitude`);
            if (!itinerary.arrival_city_longitude) missingFields.push(`arrival_city_longitude`);
          }

          //hotel — match any accommodation type (hotel/resort/apartment/bnb/boutique)
          if (itinerary?.activity_type?.toLowerCase?.()?.startsWith("accommodation.")) {
            if (!itinerary.accommodation_location_name) missingFields.push(`accommodation_location_name`);
            if (!itinerary.accommodation_location_latitude) missingFields.push(`accommodation_location_latitude`);
            if (!itinerary.accommodation_location_longitude) missingFields.push(`accommodation_location_longitude`);
            if (!itinerary.accommodation_location_city) missingFields.push(`accommodation_location_city`);
            if (!itinerary.accommodation_location_country_code)
              missingFields.push(`accommodation_location_country_code`);
          }
        });
      });
    });
    return {
      isValid: missingFields.length === 0,
      missingFields,
    };
  }

  //handle booking details
  const handleBookingDetails = (selectedChatDataArgs?: any) => {
    const selectedChatData = selectedChatDataArgs;

    const flightTravelDetailsFromItinerary = getFlightTravelDetails(
      selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList
    );
    const flightTravelData = getFlightTravelData(flightTravelDetailsFromItinerary);
    const flightTime = flightTravelData?.map((i: any) => i?.flightTime?.toLowerCase?.()) ?? [];

    const hotelStayCheck = getHotelTravelDetails(
      selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList
    );

    const selectedClass =
      selectedChatDataArgs?.flight_cabin_class?.toLowerCase?.() ??
      selectedChatData?.flight_cabin_class?.toLowerCase?.() ??
      "Economy"?.toLowerCase?.();

    const handleFlightClass = (selectedClass: string) => {
      switch (selectedClass) {
        case "Economy":
          return "E";
        case "economy":
          return "E";
        case "premium_economy":
          return "P";
        case "premium economy":
          return "P";
        case "premium":
          return "P";
        case "Business":
          return "B";
        case "business":
          return "B";
        case "First Class":
          return "F";
        case "first":
          return "F";
        default:
          return "E";
      }
    };

    const flightHistory = getTravelDetails(selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList);
    const tripType = GetTripType(flightHistory); // Get trip type
    // const airportPayload = extractFlightCities(flightHistory);
    const roomInfo = handleRoomAllocation(
      parseInt(selectedChatData?.number_of_adults),
      parseInt(selectedChatData?.number_of_children),
      parseInt(selectedChatData?.number_of_senior_infants),
      parseInt(selectedChatData?.number_of_senior_citizens),
      parseInt(selectedChatData?.number_of_rooms),
      (selectedChatData as any)?.children_ages
    );
    setBookingDetails((prevDetails) => ({
      ...prevDetails,
      adultsCount:
        (parseInt(selectedChatData?.number_of_adults ?? "") || 0) +
          (parseInt(selectedChatData?.number_of_senior_citizens ?? "") || 0) || 1,
      childrenCount: parseInt(selectedChatData?.number_of_children as string) || 0,
      infantCount: parseInt(selectedChatData?.number_of_senior_infants as string) || 0,
      seniorsCount: 0,
      adultsHotelCount: parseInt(selectedChatData?.number_of_adults as string) || 2,
      childrenHotelCount: parseInt(selectedChatData?.number_of_children as string) || 0,
      infantHotelCount: parseInt(selectedChatData?.number_of_senior_infants as string) || 0,
      seniorsHotelCount: parseInt(selectedChatData?.number_of_senior_citizens as string) || 0,
      childrenAges: Array.isArray((selectedChatData as any)?.children_ages)
        ? (selectedChatData as any).children_ages
        : [],
      travelFromDate:
        validateDate(selectedChatData?.start_date || itineraryInfo?.travelFromDate?.toLowerCase?.()) || "",
      flightClass: handleFlightClass(selectedClass) || itineraryInfo?.flightClass?.toLowerCase?.(),
      numberOfRoomCount: Number(selectedChatData?.number_of_rooms) || itineraryInfo?.numberOfRoomCount || 1,
      tripType: tripType,
      isThisMultiCityTrip: tripType === 1 ? false : tripType === 2 ? false : true,
      airPort: extractFlightSegments(selectedChatData, shouldUsenewAirportSearch),
      airlines: selectedChatData?.airlines?.toLowerCase?.() ?? "",
      hotelChains: selectedChatData?.hotels?.toLowerCase?.() ?? "",
      // LLM emits accommodation_type under hotels.accommodation_type, which
      // the streaming handler surfaces as selectedChatData.accommodation_type
      // (top-level). Fall back to the legacy misspelled `accomadation_types`
      // for any path that still populates it.
      accommodationTypes:
        selectedChatData?.accommodation_type?.toLowerCase?.() ??
        selectedChatData?.accomadation_types?.toLowerCase?.() ??
        "",
      flightDayPart: selectedChatData?.flight_day_part?.toLowerCase?.() ?? "",
      numberOfStops: convertRangeToString(selectedChatData?.number_of_stops?.toLowerCase?.()) || "",
      flightRefundable: selectedChatData?.flight_refundable?.toLowerCase?.() ?? null,
      numberOfDays: selectedChatData?.number_of_days ?? 1,
      selectedFlightId: "",
      flightPreferences: {
        connections:
          selectedChatData?.flights?.number_of_stops ??
          (selectedChatData?.number_of_stops != null && selectedChatData?.number_of_stops !== ""
            ? selectedChatData.number_of_stops === "non-stop"
              ? 0
              : Number(selectedChatData.number_of_stops)
            : null),
        departureTime: parseAirlineNames(selectedChatData?.flights?.time_of_day ?? flightTime),
        refundable: selectedChatData?.flight_refundable ?? selectedChatData?.flights?.flight_refundable ?? null,
        airlines: selectedChatData?.flights?.airlines ?? parseAirlineNames(selectedChatData?.airlines?.toLowerCase?.()),
      },
      hotelPreferences: {
        refundable: selectedChatData?.hotel_refundable ?? null,
        hotelChains:
          Array.isArray(selectedChatData?.hotels) && selectedChatData.hotels.every((h: string) => typeof h === "string")
            ? selectedChatData.hotels
            : [],
        accommodationTypes: parseAirlineNames(
          selectedChatData?.accommodation_type?.toLowerCase() ||
          selectedChatData?.accomadation_types?.toLowerCase() ||
          "hotel"
        ),
        userRatings: null,
        starRatings:
          Array.isArray(selectedChatData?.hotel_star_ratings) &&
          selectedChatData?.hotel_star_ratings.every((s: number) => typeof s === "number")
            ? selectedChatData?.hotel_star_ratings
            : [],
      },
      visibleList: {
        flight: 0,
        hotel: 0,
        package: 2,
      },
      filters: {
        starRating: selectedChatData?.hotel_star_ratings?.toLowerCase?.()
          ? hotelRatingParse(selectedChatData?.hotel_star_ratings?.toLowerCase?.())
          : hotelRatingParse(""),
      },
      roomInfo:
        roomInfo?.length > 0
          ? roomInfo
          : [
              {
                roomNo: 1,
                adults: 2,
                child: 0,
                childAges: "",
              },
            ],
    }));
    // Clear data
    setFlightData(null);
    setHotelData(null);
    setPrevRoute(ROUTES.ItineraryDetails);
    // Set UI state
    setShowMore({ visibleList: { flight: 0, hotel: 4, package: 4 } });
    setHotelPagination([]);
  };

  //Missing Fields

  // handle book function
  const handleBook = async (selectedChatDataArgs: any, clickFromActivity?: boolean) => {
    // Shared-trip clone-on-Book: if the trip was hydrated from /shared/:id,
    // either (a) recognize the viewer as the source owner and just stamp
    // travelPlanId = sourceId, or (b) clone the source into the viewer's
    // account before any of the booking-flow state mutations below run.
    // Without this, handleBook would operate on a borrowed plan id,
    // saveItineraryBeforeBooking would race with the firstScreen swap, and
    // the chat column would briefly fall back to the empty "More Places"
    // card. The helper is a no-op when the trip is already owned in the
    // local sense (no sharedSourceTravelPlanId or travelPlanId already
    // set), so this stays cheap on the normal flow.
    const cloneResult = await cloneSharedTravelPlanIfNeeded({
      selectedChatData: selectedChatDataArgs,
      accessJWT,
      userId: userInfo?.id,
    });
    // eslint-disable-next-line no-console
    console.log("[BOOK-FLOW] cloneResult:", {
      cloned: cloneResult.cloned,
      alreadyOwned: cloneResult.alreadyOwned,
      travelPlanId: cloneResult.travelPlanId,
      argTravelPlanId: selectedChatDataArgs?.travelPlanId,
      argSharedSourceFlag: selectedChatDataArgs?.sharedSourceTravelPlanId,
    });
    if (cloneResult.cloned || cloneResult.alreadyOwned) {
      selectedChatDataArgs = cloneResult.next;
      // Mirror travelPlanId + clear sharedSourceTravelPlanId on the
      // synthetic share-flow bubble in chatData so the saveItineraryBefore-
      // Booking map below finds it by id, the bubble keeps its preText /
      // destinationList while the book flow runs, AND a future chat send
      // doesn't see sharedSourceTravelPlanId again and re-trigger the
      // helper.
      const stampedTravelPlanId = cloneResult.travelPlanId;
      const stampSavedFlag = cloneResult.alreadyOwned;
      setChatData((prev: iChatData[]) =>
        Array.isArray(prev)
          ? prev.map((entry: any) =>
              entry?.sharedSourceTravelPlanId
                ? {
                    ...entry,
                    travelPlanId: stampedTravelPlanId,
                    sharedSourceTravelPlanId: undefined,
                    ...(stampSavedFlag ? { isSaved: true } : {}),
                  }
                : entry
            )
          : prev
      );
    }
    setSelectedChatData(selectedChatDataArgs);
    if (cancelHandleBookClickRef) cancelHandleBookClickRef.current = "";
    if (isMobile) navigateWithParams(ROUTES.BookingLoader);
    else {
      setScreen(ScreenTypes.BookingLoader);
      if (firstScreen === ScreenTypes.SavedTrip) setFirstScreen(ScreenTypes.SavedTrip);
      else setFirstScreen(ScreenTypes.topDestination);
    }
    setAskZoyaRecordId({
      flights: "",
      hotels: [],
    });
    setItemInSessionStorage(ASKZOYA_CONST.localStorageKey.flights, JSON.stringify([]));
    setItemInSessionStorage(ASKZOYA_CONST.localStorageKey.hotels, JSON.stringify([]));
    setRecentTravelersList([]);
    setHotelTravelersList([]);
    setGuestList([]);
    hasCancelledRef.current = false;
    // setBreadList(INITIAL_BREADCRUMBS_LIST);
    setSelectedHotels([]);
    setFlightAvailabilityData(null);
    // setBookingDetails((prev: any) => ({
    //   ...prev,
    //   selectedFlightId: "",
    // }));
    setSelectedHotelRoomArr([]);
    setSignInClick(true);
    localStorage.removeItem("_traveler_info_array");
    setIsFetchingMobileAirports(true);
    setIsFetchingAirports(true);
    setIsDataUpdateComplete(false);
    setUpdateFilters(true);
    setHideDetails(true);
    // setFlightTTL(null);
    await handleBookingDetails(selectedChatDataArgs);
    try {
      const airportData = await getAirportData(selectedChatDataArgs).catch(() => {
        console.warn("Airport API failed");
        return null;
      });

      const flightTravelDetails = getFlightTravelDetails(
        selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList
      );
      const hotelStayCheck = getHotelTravelDetails(
        selectedChatDataArgs?.destinationList ?? selectedChatData?.destinationList
      );
      if (!clickFromActivity && !bookClickFromItinerary) {
        setSelectedFlightOptions({
          ...selectedFlightOptions,
          flights: flightTravelDetails?.some((item: any) => item?.flights?.length > 0),
          hotels: !hotelStayCheck,
        });
      }
      // saveItineraryBeforeBooking POSTs `/app/v1/users/itineraries` with the
      // full chat payload. Direct (Shop Travel) bookings don't have any chat
      // content — the placeholder `selectedChatData` they enter handleBook with
      // has an `id` UUID but empty `results`/`complete_itinerary_description`/
      // `city_wise_itinerary`/`messages`. The save row for direct bookings is
      // instead created by `createItineraryAPI` during prebook in
      // TravelerCrumbsDetailsContext, so firing this call here too produced
      // a duplicate `/app/v1/users/itineraries` POST with mostly-empty fields.
      // Only save when there's actual chat content to persist.
      const hasChatContent = !!(
        selectedChatDataArgs?.results ||
        selectedChatDataArgs?.complete_itinerary_description ||
        (Array.isArray(selectedChatDataArgs?.city_wise_itinerary) &&
          selectedChatDataArgs.city_wise_itinerary.length > 0) ||
        (Array.isArray(selectedChatDataArgs?.messages) &&
          selectedChatDataArgs.messages.length > 0)
      );
      if (userInfo?.loggedIn && selectedChatDataArgs?.id && hasChatContent) {
        const savedBackendId = await saveItineraryBeforeBooking(selectedChatDataArgs);
        if (!userInfo?.id || savedBackendId === null) {
          setIsFetchingMobileAirports(false);
          setIsFetchingAirports(false);
          return;
        }
        // Propagate backend id onto the local args so the downstream
        // setSelectedChatData below doesn't regress id back to the client UUID.
        // The later "Next: payment method" PUT relies on selectedChatData.id
        // being the real backend record id.
        if (savedBackendId) {
          selectedChatDataArgs = { ...selectedChatDataArgs, id: savedBackendId, isSaved: true };
        }
      }
      consoleLog(["BOOKING CANCEL 1", cancelHandleBookClickRef?.current]);
      if (!airportRequestInProgress.current && cancelHandleBookClickRef?.current !== "CANCEL") {
        handleNavigateToBooking();
      }
    } catch (error) {
      console.error("Error during booking process:", error);
      setIsFetchingMobileAirports(false);
      setIsFetchingAirports(false);
    }
    setSelectedChatData(selectedChatDataArgs);
    updateHotelPayloadData(setBookingDetails, selectedChatDataArgs, selectedChatDataArgs?.start_date);
  };
  const value = {
    handleNavigateToBooking,
    saveItineraryBeforeBooking,
    fetchAirportController,
    openModifyItineraryDialog,
    setOpenModifyItineraryDialog,
    handleBackButton,
    noOfCitySelected,
    handleNav,
    handleSaveItinerary,
    handleOnShare,
    handleShare,
    handleBook,
    tempSelectedChatData,
    handleEditActivity,
    disableInput,
    showEditActivityFlag,
    setShowEditActivityFlag,
    handleSendMessage: STREAMING_ENABLE ? handleSendMessageStreaming : handleSendMessage,
    inputValue,
    setInputValue,
    handleCancel: STREAMING_ENABLE ? handleCancelStreaming : handleCancel,
  };
  return <ItineraryContext.Provider value={value}>{children}</ItineraryContext.Provider>;
};
export const useItineraryContext = () => useContext(ItineraryContext);
